import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
    font-size: 100%;
    -webkit-text-size-adjust: 100%;
    text-size-adjust: 100%;
    --color-main: ${({ theme }) => theme.colors.main};
    --color-mainDark: ${({ theme }) => theme.colors.mainDark};
    --color-mainLight: ${({ theme }) => theme.colors.mainLight};
    --color-mainLighter: ${({ theme }) => theme.colors.mainLighter};
    --color-accent: ${({ theme }) => theme.colors.accent};
    --color-accentDark: ${({ theme }) => theme.colors.accentDark};
    --color-accentSoft: ${({ theme }) => theme.colors.accentSoft};
    --color-text: ${({ theme }) => theme.colors.textColor};
    --color-muted: ${({ theme }) => theme.colors.mutedText};
    --color-white: ${({ theme }) => theme.colors.whiteColor};
    --color-surface: ${({ theme }) => theme.colors.surface};
    --color-surfaceMuted: ${({ theme }) => theme.colors.surfaceMuted};
    --color-background: ${({ theme }) => theme.colors.surfaceMuted};
    --color-border: #e5e1da;
    --color-borderStrong: #d4cdc2;
    --color-text-muted: ${({ theme }) => theme.colors.mutedText};
    --color-textMuted: ${({ theme }) => theme.colors.mutedText};
    --radius-sm: .75rem;
    --radius-md: 1rem;
    --radius-lg: 1.35rem;
    --radius-xl: 1.75rem;
    --shadow-xs: 0 1px 2px rgba(0,0,0,.04);
    --shadow-sm: 0 14px 36px rgba(0, 0, 0, 0.07);
    --shadow-md: 0 22px 55px rgba(0, 0, 0, 0.11);
    --color-errorRed: ${({ theme }) => theme.colors.errorRed};
    --color-success: ${({ theme }) => theme.colors.successGreen};
    --shadow: ${({ theme }) => theme.colors.shadow};
    --page-width: 82rem;
  }

  html,
  body,
  #root {
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
    overflow-x: clip;
  }

  body {
    margin: 0;
    overscroll-behavior-y: none;
    touch-action: manipulation;
    min-width: 320px;
    min-height: 100vh;
    color: var(--color-text);
    background: var(--color-surfaceMuted);
    font-family: "Manrope", Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont,
      "Segoe UI", sans-serif;
    font-weight: 500;
    line-height: 1.52;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin-top: 0;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 800;
    letter-spacing: -0.04em;
    color: var(--color-mainDark);
  }

  button, [role="button"] {
    letter-spacing: -0.015em;
  }

  img {
    display: block;
    max-width: 100%;
  }

  main,
  section,
  article,
  aside,
  header,
  footer,
  nav {
    min-width: 0;
  }

  button,
  input,
  textarea,
  select {
    max-width: 100%;
    font: inherit;
  }

  input,
  textarea,
  select {
    min-width: 0;
  }

  textarea {
    overflow-wrap: anywhere;
  }

  button,
  a {
    -webkit-tap-highlight-color: transparent;
  }

  button {
    touch-action: manipulation;
  }

  a {
    color: inherit;
  }

  :focus-visible {
    outline: 3px solid rgba(192, 163, 117, 0.48);
    outline-offset: 3px;
  }

  ::selection {
    color: #000;
    background: rgba(192, 163, 117, 0.38);
  }

  .Toastify__toast-container {
    z-index: 20000;
  }

  .Toastify__toast-container--top-right,
  .Toastify__toast-container--top-center,
  .Toastify__toast-container--top-left {
    top: calc(5.15rem + env(safe-area-inset-top));
  }

  .Toastify__toast {
    border: 1px solid var(--color-border);
    border-radius: 1rem;
    box-shadow: var(--shadow-md);
    font-family: inherit;
  }

  @media (max-width: 56rem) {
    /* iOS Safari zooms the viewport when a focused form control renders below
       16px. Keep every app form at 16px on touch-sized layouts so closing a
       modal or leaving a field never strands the user in a zoomed viewport. */
    input,
    textarea,
    select {
      font-size: 16px !important;
      line-height: 1.4;
    }

    input[type="checkbox"],
    input[type="radio"],
    input[type="range"],
    input[type="file"] {
      font-size: inherit !important;
    }

    button,
    [role="button"],
    a {
      touch-action: manipulation;
    }
  }

  @media (max-width: 40rem) {
    body {
      line-height: 1.48;
    }

    .Toastify__toast-container--top-right,
    .Toastify__toast-container--top-center,
    .Toastify__toast-container--top-left {
      top: calc(4.65rem + env(safe-area-inset-top));
      left: .55rem;
      right: .55rem;
      width: auto;
      transform: none;
    }

    .Toastify__toast {
      min-height: 3.25rem;
      margin-bottom: .55rem;
      border-radius: .9rem;
    }
  }
`;
